import { Component, OnInit, Input } from '@angular/core';
import { Line } from '@app/core';
import { ICombineEngine } from '@app/shared/interfaces';
import { sortBy } from 'lodash';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
    @Input() model: { engine: ICombineEngine, line: Line };
    extraValuesList: Array<any> = [];
    boaddedvalueList: Array<any> = [];
    mealPlanValuesList: Array<any> = [];
    bomealPlanValuesList: Array<any> = [];
    mealPlanInfoValuesList: Array<any> = [];
    saleConditionValuesList: Array<any> = [];
    saleConditionInfoValuesList: Array<any> = [];
    specialconditionValuesList: Array<any> = [];
    freebreakfast: boolean = false;

    constructor() { }

    ngOnInit() {
        this.freebreakfast = this.model.engine.combine.offer_freebreakfast;
        // console.log(this.model.engine.combine.addedvalues);
        if (!!this.model.engine.combine.addedvalues) {
            [].forEach.call(this.model.engine.combine.addedvalues, element => {
                // console.log(element.category , element);
                if (element.category == 'addedvalue') {
                    this.extraValuesList.push(element);
                }
                if (element.category == 'boaddedvalue') {
                    this.boaddedvalueList.push(element);
                }
                if (element.category == 'mealplan') {
                    this.mealPlanValuesList.push(element);
                }
                if (element.category == 'bomealplan') {
                    this.bomealPlanValuesList.push(element);
                }
                if (element.category == 'mealplaninformation') {
                    this.mealPlanInfoValuesList.push(element);
                }
                if (element.category == 'salecondition') {
                    this.saleConditionValuesList.push(element);
                }
                if (element.category == 'saleconditioninformation') {
                    this.saleConditionInfoValuesList.push(element);
                }
                if (element.category == 'specialcondition') {
                    this.specialconditionValuesList.push(element);
                }
            });
            this.extraValuesList = sortBy(this.extraValuesList, ['sorting']);
            this.boaddedvalueList = sortBy(this.boaddedvalueList, ['sorting']);
            this.mealPlanValuesList = sortBy(this.mealPlanValuesList, ['sorting']);
            this.bomealPlanValuesList = sortBy(this.bomealPlanValuesList, ['sorting']);
            this.mealPlanInfoValuesList = sortBy(this.mealPlanInfoValuesList, ['sorting']);
            this.saleConditionValuesList = sortBy(this.saleConditionValuesList, ['sorting']);
            this.saleConditionInfoValuesList = sortBy(this.saleConditionInfoValuesList, ['sorting']);
            this.specialconditionValuesList = sortBy(this.specialconditionValuesList, ['sorting']);
        }
    }

}
